import { Add, Delete } from '@mui/icons-material'
import { Button, IconButton, Typography } from '@mui/material'
import axios from 'axios'
import { useCallback, useContext, useState } from 'react'
import { Link } from 'react-router-dom'

import { AuthContext } from '../../utils/authContext'
import { getBaseURL } from '../../utils/getBaseURL'

import { CreateNewInventory } from './createInventoryForm'

export const InventoryManager = () => {
  const authContext = useContext(AuthContext)
  const [createFormOpen, setCreateFormOpen] = useState(false)

  const onDelete = useCallback(
    (id: string) => {
      axios
        .delete(`${getBaseURL()}/inventories/${id}`)
        .then(() => authContext.reloadUserData())
        .catch((err) => console.error(err))
    },
    [authContext]
  )

  return (
    <div>
      <Typography variant="h4">Inventory Manager</Typography>
      <Button onClick={() => setCreateFormOpen(true)}>
        <Add />
        Create New
      </Button>
      <table cellSpacing={10}>
        <thead>
          <tr>
            <th>Inventory</th>
            <th>id / username</th>
            <th>passkey</th>
            <th>created at</th>
            <th>based on</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {authContext.permittedInventores.map((inv) => (
            <tr key={inv.id}>
              <td>
                <Link to={`/inventory/${inv.id}`}>{inv.name}</Link>
              </td>
              <td>
                <code style={{ backgroundColor: '#DDD', borderRadius: 4 }}>{inv.id}</code>
              </td>
              <td>
                <code style={{ backgroundColor: '#DDD', borderRadius: 4 }}>{inv.passkey}</code>
              </td>
              <td>{new Date(inv.createdAt).toLocaleString()}</td>
              <td>
                {inv.previous
                  ? authContext.permittedInventores.find((i) => i.id === inv.previous)?.name ?? 'Unknown Inventory'
                  : 'Main Inventory'}
              </td>
              <td>
                <IconButton onClick={() => onDelete(inv.id)}>
                  <Delete />
                </IconButton>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <CreateNewInventory isOpen={createFormOpen} onDismiss={() => setCreateFormOpen(false)} />
    </div>
  )
}
